import { useEffect } from "react"

import useFetch from "shared/model/useFetch"

const useGetMy = () => {
    const [fetchResult, fetchRequest] = useFetch()

    useEffect(() => {
        fetchRequest("GET", `/admin/my`)
    }, [])

    return [fetchResult]
}

export default useGetMy